import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import * as XLSX from "xlsx";
import {
  ButtonDropdown,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  Popover,
  PopoverBody,
  PopoverHeader,
  FormFeedback,
  FormText,
} from "reactstrap";
import PreLoader from "../../share-components/ui/preLoader";
import Breadcrumbs from "../../layout/breadcrumb";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { DateRangePicker } from "rsuite";
import DatePicker from "../../share-components/ui/DateRangePicker";
import BackInStockTable from "../backInStock/content/backInStockTable";
import withReducer from "../../store/withReducer";
import discountReducer from "./store";
import {
  getAllPromotionDiscounts,
  getDiscountSettings,
  getPromotionSettings,
  selectDiscounts,
  setDiscountSettings,
  setSettings,
} from "./store/discountSlice";
import moment from "moment";
import CommonDataTable from "../../share-components/table/commonDataTable";

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};

function DiscountLists() {
  const dispatch = useDispatch();
  let history = useHistory();
  const TodayDate = new Date();
  const sevenDays = new Date().setDate(TodayDate.getDate() - 90);
  const discountState = useSelector(({ discount }) => discount.discount);
  const [loading, setLoading] = useState(true);
  const [isChecked, setIsChecked] = useState(null);
  const [itemIdArray, setItemIdArray] = useState([]);
  const [orderCheckBoxData, setOrderCheckBoxData] = useState({ idArray: [] });
  const [dateRange, setDateRange] = useState([sevenDays, TodayDate]);
  const [startDate, endDate] = dateRange;
  const [name, setName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectDiscountType, setSelectDiscountType] = useState(null);
  const [discountStatus, setDiscountStatus] = useState(null);
  const [createdBy, setCreatedBy] = useState(null);
  const [timer, setTimer] = useState(null);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    dispatch(getPromotionSettings())
      .then((res) => {
        dispatch(setSettings(res.payload));
      })
      .catch(() => {
        console.log("Failed to load promotion settings");
      });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDiscountSettings())
      .then((res) => {
        dispatch(setDiscountSettings(res.payload));
      })
      .catch(() => {
        console.log("Failed to load discount settings");
      });
  }, [dispatch]);

  useEffect(() => {
    retrieveData();
  }, [dispatch, name, pageSize, startDate, endDate, selectDiscountType, discountStatus, createdBy, currentPage]);

  const retrieveData = () => {
    const data = {
      name,
      page_size: pageSize,
      start_date: startDate ? moment(startDate).format("YYYY-MM-DD HH:mm:ss") : "",
      end_date: endDate ? moment(endDate).format("YYYY-MM-DD HH:mm:ss") : "",
      type: selectDiscountType?.id,
      status: discountStatus?.id,
      created_by: createdBy?.id,
      page: currentPage,
    };
    setLoading(true);
    dispatch(getAllPromotionDiscounts({ ...data }))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };

  const discountData = useSelector(selectDiscounts);

  let tableColumns = [
    {
      name: "Name",
      selector: (row) => row.title,
      sortable: true,
      center: false,
    },
    {
      name: "Start Date",
      selector: (row) => row.start_date,
      sortable: true,
      center: false,
    },
    {
      name: "End Date",
      selector: (row) => row.expiry_date,
      sortable: true,
      center: false,
    },
    {
      name: "Discount Type",
      sortable: true,
      center: false,
      selector: (row) => {
        const disType = promotionType.filter((dis) => dis.id === row.type);
        return <p>{disType[0]?.name}</p>;
      },
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      center: false,
    },
    {
      name: "Created By",
      selector: (row) => row.created_by,
      sortable: true,
      center: false,
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          <a
            onClick={() => {
              onEdit(row);
            }}
            style={{cursor:"pointer"}}
          >
            <i className="fa fa-pencil" style={{ width: 25, fontSize: 16, padding: 11, color: "rgb(40, 167, 69)" }}></i>
          </a>
        </div>
      ),
      sortable: false,
      center: true,
    },
  ];

  let idArray = [];

  const dataMenu = [
    {
      type: 0,
      text: "Discounts",
    },
  ];

  const allSellers = [
    { value: 1, label: "Methan" },
    { value: 2, label: "Vishnu" },
  ];

  const promotionType = [
    { id: 1, name: "Buy 1 get 1" },
    { id: 2, name: "Buy X get Y" },
    { id: 3, name: "Amount off product" },
    { id: 4, name: "Amount off order" },
    { id: 5, name: "Free shipping" },
  ];

  const onAdd = () => {
    history.push("/discounts/new");
  };
  const onEdit = (val) => {
    history.push(`/discount/${val.id}/edit`);
  };

  const pageChange = (e) => {
    setCurrentPage(e);
  };
  const toggleRowSelected = (id) => {};

  const handleChange = (state) => {
    if (state.selectedCount > 0) {
      setIsChecked(true);
      state.selectedRows.map((item, i) => {
        if (idArray.includes(item.id) !== -1) {
          idArray.push(item.id);
          // setItemIdArray(idArray);
          setOrderCheckBoxData((prevState) => ({
            idArray: [...prevState.idArray, ...idArray],
          }));
        }
      });
    }

    idArray = Array.from(new Set(idArray));
    setItemIdArray(idArray);
  };

  const onPageSizeChange = (e) => {
    setCurrentPage(1)
    setPageSize(e);
  };

  return (
    <Fragment>
      <Breadcrumbs title="Promotion Discounts" data={dataMenu} />
      <Container fluid={true} className="product-wrapper">
        <div className="product-grid">
          {/* Add New Discount Header */}
          <div className="feature-products">
            <Card>
              <Row style={{ alignItems: "center", justifyContent: discountState?.activeListing?.isActiveDiscount ? "space-between" : "end" }}>
                {discountState?.activeListing?.isActiveDiscount && (
                  <>
                    <Col sm="3">
                      <div className="p-3 d-flex flex-row">
                        <div
                          style={{
                            backgroundColor: "rgb(158 255 193 / 62%)",
                            color: "rgb(0 154 7)",
                            width: "max-content",
                            padding: "5px 12px",
                            borderRadius: "5px",
                          }}
                        >
                          Active Discount : {discountState?.activeListing?.activeDiscountCount}
                        </div>
                      </div>
                    </Col>
                    {discountState?.activeListing?.activeDiscountCount === 24 && (
                      <Col sm="6">
                        <div>
                          <p className="text-danger">Shopify can have only active 25 discount. Please deactive one and try again</p>
                        </div>
                      </Col>
                    )}
                  </>
                )}
                <Col sm="3">
                  <div className="float-sm-right p-3">
                    <a onClick={onAdd} className="btn btn-sm btn-success">
                      {" "}
                      <i className="fa fa-plus"></i> Add Discount
                    </a>
                  </div>
                </Col>
              </Row>
            </Card>
          </div>

          {/* Filter Section */}
          <Row>
            <Col md={3}>
              <div className="dashboard-datepicker">
                <DatePicker
                  dateRange={dateRange}
                  dateRangeChange={(date) => {
                    setDateRange(date);
                  }}
                  defaultValue={[TodayDate, sevenDays]}
                  paddingLeft={0}
                />
              </div>
            </Col>

            <Col md={2}>
              <Select
                placeholder="Discount Type"
                className="select2-filter"
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                isClearable
                cacheOptions
                styles={customStyles}
                options={discountState?.settings.discountType}
                onChange={(selectedOption) => {
                  setSelectDiscountType(selectedOption);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
              />
            </Col>
            <Col md={2}>
              <Select
                placeholder="Status"
                className="select2-filter"
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                isClearable
                cacheOptions
                styles={customStyles}
                options={discountState?.settings.status}
                onChange={(selectedOption) => {
                  setDiscountStatus(selectedOption);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
              />
            </Col>
            <Col md={2}>
              <Select
                placeholder="Created by"
                className="select2-filter"
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                isClearable
                cacheOptions
                styles={customStyles}
                options={discountState?.settings.users}
                onChange={(e) => {
                  setCreatedBy(e ? e : null);
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
              />
            </Col>
            <Col md={3}>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <FormGroup className="m-0">
                  <Input
                    bsSize="lg"
                    type="text"
                    defaultValue={name}
                    onChange={(e) => {
                      clearTimeout(timer);

                      const newTimer = setTimeout(() => {
                        setName(e.target.value);
                      }, 500);

                      setTimer(newTimer);
                    }}
                    placeholder="Search Discount"
                  />
                </FormGroup>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col className="mt-3" sm="12">
              {loading ? (
                <Card style={{ minHeight: 400 }}>
                  <CardBody>
                    <PreLoader />
                  </CardBody>
                </Card>
              ) : (
                <>
                  <Card>
                    <CardBody>
                      <div className="table-responsive product-table">
                        <CommonDataTable
                          headerColumns={tableColumns}
                          gridData={discountData}
                          paginationServer
                          noAction
                          paginationTotalRows={discountState.tableRowCount}
                          paginationRowsPerPageOptions={[10, 25, 50, 100]}
                          onChangeRowsPerPage={onPageSizeChange}
                          onChangePage={pageChange}
                          paginationDefaultPage={currentPage}
                          paginationPerPage={pageSize}
                        />
                      </div>
                    </CardBody>
                  </Card>
                </>
              )}
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
}

export default withReducer([{ discount: discountReducer }])(DiscountLists);
